import LoadingComponent from "./LoadingComponent";

const setTitle = title => {
    document.title = `${title} | PayEx DesignGuide`;
};

export {
    setTitle,
    LoadingComponent
};
